import { render } from "./HsDataTable.vue?vue&type=template&id=1edfd0df"
import script from "./HsDataTable.vue?vue&type=script&lang=js"
export * from "./HsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__